export const BodyTemperatureRecipe = {
    $type$: 'Recipe',
    name: 'BodyTemperature',
    rule: [
        {
            itemprop: 'temperature',
            itemtype: { type: 'number' }
        },
        {
            itemprop: 'patientId',
            itemtype: { type: 'string' },
            optional: true
        }
    ]
};
const BodyTemperatureRecipes = [BodyTemperatureRecipe];
export default BodyTemperatureRecipes;
//# sourceMappingURL=BodyTemperatureRecipe.js.map